
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, Event, NavigationCancel, NavigationError } from '@angular/router';

import { BsModalRef, ModalDirective } from 'ngx-bootstrap';

import { AuthService } from './shared/services/auth.service';


@Component({  
  selector: 'body',
  styles: [`
    .mask {
      margin: 0;
      padding: 0;    
      height: 100vh;
      width: 100%;
      position: fixed;
      top: 0;
      background-color: rgba(0,0,0,0.6);
      left: 0;
      z-index: 9999;
    }
    
    .loading{
      width: 200px;
      height: 200px;
      box-sizing: border-box;
      border-radius: 50%;
      border-top: 10px solid #c0392b;
      position: relative;
      animation: a1 2s linear infinite;
    }
    
    .loading::before,.loading::after{
      content: '';
      width: 200px;
      height: 200px;
      position: absolute;
      left: 0;
      top: -10px;
      box-sizing: border-box;
      border-radius: 50%;  
    }
    
    .loading::before{
      border-top: 10px solid #f1c40f;
      transform: rotate(120deg);
    }
    
    .loading::after{
      border-top: 10px solid #474787;
      transform: rotate(240deg);
    }
    
    .loading span{
      position: absolute;
      width: 200px;
      height: 200px;
      color: #FFF;
      font-weight: 900;
      text-align: center;
      line-height: 200px;
      animation: a2 2s linear infinite;
    }
    
    @keyframes a1 {
      to{
        transform: rotate(360deg);
      }
    }
    
    @keyframes a2 {
      to{
        transform: rotate(-360deg);
      }
    }
  `],
  template: `
  
    <div class="mask" *ngIf="loading" style="z-index: 9999!important;">
      <div class="loading" style="z-index: 9999!important;">
        <span>Carregando...</span>
      </div>
    </div>
    
    <router-outlet></router-outlet>     
    
  `
})
export class AppComponent implements OnInit {
  public loading: boolean = false;
        
  constructor(
    private router: Router, 
    private authService: AuthService,        
  ) {
                 
    this.router.events.subscribe((event: Event) => {
          
      switch (true) {
        case event instanceof NavigationStart: {
          this.loading = true;
          break;
        }

        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          
          this.loading = false;
          break;
        }
        default: {
          
          break;
        }
      }
    });
  }

  
  ngOnInit() {        
  }  

  logout() {
    this.authService.setUserLoggedIn(false);
    this.authService.logout();
    this.router.navigate(["/login"]);
  }
}
